<script setup>
import ImageComponent from '@/components/common/ImageComponent.vue';
import { computed, toRefs } from 'vue';

const props = defineProps({
  emphasizeType: {
    type: String,
    default: '',
  },
  image: {
    type: Object,
    default: () => ({}),
  },
});

const {
  emphasizeType,
  image,
} = toRefs(props);

const imageClassList = computed(() => {
  if (!image.value?.url) {
    return 'd-none';
  }

  if (!['IMAGE', 'ITEM_LIST'].includes(emphasizeType.value)) {
    return 'd-none';
  }

  return '';
});

</script>
<template>
  <div
    class="preview-message__inner-noticeimg"
    :class="imageClassList"
  >
    <ImageComponent
      :src="image.url"
      alt="image"
    />
  </div>
</template>
